// extracted by mini-css-extract-plugin
module.exports = {"sp-only":"index_sp-only__MXAz3","pc-only":"index_pc-only__qcEi4"};